import {Region} from "platformed-client/types";
import {platformedClient} from "../index";

export async function listRegions(): Promise<Region[]> {
  return await platformedClient.internalRequest("get", "/api/internal/regions", {});
}
